// src/admin/utils/tokenUtils.js

import { ADMIN_CLIENT_ID, ADMIN_CLIENT_SECRET } from '../../config/env';

// Keys for localStorage
export const ACCESS_TOKEN_KEY = 'admin_access_token';
export const REFRESH_TOKEN_KEY = 'admin_refresh_token';

// Get tokens from localStorage
export function getStoredTokens() {
  return {
    accessToken: localStorage.getItem(ACCESS_TOKEN_KEY),
    refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY),
  };
}

// Save tokens to localStorage
export function storeTokens(accessToken, refreshToken) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

// Remove tokens from localStorage
export function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

// Basic auth header for client credentials
export function getBasicAuthHeader() {
  return 'Basic ' + btoa(`${ADMIN_CLIENT_ID}:${ADMIN_CLIENT_SECRET}`);
}
